import { onAuthStateChanged } from "firebase/auth";
import { auth } from "../firebase";

const TOKEN_STORAGE_KEY = "auth_token";

const isBrowser = typeof window !== "undefined";
let authReadyPromise: Promise<void> | null = null;

const removeLegacyStoredToken = () => {
  if (isBrowser) {
    window.localStorage.removeItem(TOKEN_STORAGE_KEY);
  }
};

const waitForAuthState = async () => {
  if (!isBrowser || auth.currentUser) return;

  if (!authReadyPromise) {
    authReadyPromise = new Promise((resolve) => {
      const unsubscribe = onAuthStateChanged(
        auth,
        () => {
          unsubscribe();
          resolve();
        },
        () => {
          unsubscribe();
          resolve();
        },
      );
    });
  }

  await authReadyPromise;
};

export const storeIdToken = (token: string) => {
  void token;
  removeLegacyStoredToken();
};

export const clearStoredToken = () => {
  removeLegacyStoredToken();
};

export const getStoredToken = (): string | null => {
  removeLegacyStoredToken();
  return null;
};

export const getIdToken = async (forceRefresh = false): Promise<string | null> => {
  await waitForAuthState();

  const currentUser = auth.currentUser;
  if (!currentUser) {
    clearStoredToken();
    return null;
  }

  try {
    const token = await currentUser.getIdToken(forceRefresh);
    clearStoredToken();
    return token;
  } catch (error) {
    console.error("Failed to retrieve Firebase ID token", error);
    clearStoredToken();
    return null;
  }
};
